export default __webpack_public_path__ + "static/media/Asech.ecb3c4f9.svg";